import { useState } from "react";
import { SimpleTable } from "../../ui/SimpleTable/SimpleTable";
import { useFetchAllVehicleStatus } from "../../../../../hooks/guide/useFetchAllVehicleStatus";
import { VehicleStatus } from "../../../../../types/api/guide/vehicleStatus.types";
import { VehicleStatusAddModal } from "../../ui/EntityModal/VehicleStatusAddModal";
import useAppSnackbar from "../../../../../hooks/useAppSnackbar";

interface VehicleStatusesTableProps {
    title: string;
}

export const VehicleStatusesTable = ({ title }: VehicleStatusesTableProps) => {
    const { data: vehicleStatuses, refetch } = useFetchAllVehicleStatus();
    const {  SnackbarComponent } = useAppSnackbar();
    // const [toDelete, setToDelete] = useState<VehicleStatus | null>(null);

    const [openModal, setOpenModal] = useState<{ isOpen: boolean; id?: string }>({
        isOpen: false,
        id: undefined,
    });

    // const handleDelete = async (id: string) => {
    //     try {
    //         await vehicleStatusService.delete(id);
    //         showSuccess("Успешное удаление")
    //         refetch();
    //     } catch (e) {
    //         showError(e.response.data);
    //         console.log("Ошибка при удалении статуса машины");
    //     }
    // };

    return (
        <>
            {/*<SimpleTable<VehicleStatus>*/}
            {/*    title={title}*/}
            {/*    columns={[{ key: "name", title: "Название" }]}*/}
            {/*    data={vehicleStatuses}*/}
            {/*    getRowKey={(r) => r.id}*/}
            {/*    // getRowActions={(row) => ({*/}
            {/*    //     onEdit: () => setOpenModal({ isOpen: true, id: row.id }),*/}
            {/*    //     onDelete: () => setToDelete(row),*/}
            {/*    // })}*/}
            {/*    emptyText="Справочник пуст"*/}
            {/*    setOpen={() => setOpenModal({ isOpen: true, id: undefined })}*/}
            {/*/>*/}
            <SimpleTable<VehicleStatus>
                title={title}
                columns={[{ key: "name", title: "Название" }]}
                data={vehicleStatuses}
                enableSearchByName
                getRowKey={(r) => r.id}
                isNeedActions={false}
                emptyText="Справочник пуст"
                setOpen={() => setOpenModal({ isOpen: true, id: undefined })}
            />
            {/*<ConfirmDialog*/}
            {/*    open={!!toDelete}*/}
            {/*    title="Удалить статус ТС?"*/}
            {/*    description={toDelete ? `Будет удалён: ${toDelete.name}` : undefined}*/}
            {/*    onCancel={() => setToDelete(null)}*/}
            {/*    onConfirm={() => {*/}
            {/*        if (!toDelete) return;*/}
            {/*        handleDelete(toDelete.id);*/}
            {/*        setToDelete(null);*/}
            {/*    }}*/}
            {/*/>*/}

            {openModal.isOpen && (
                <VehicleStatusAddModal
                    id={openModal.id}
                    onClose={() => setOpenModal({ isOpen: false, id: undefined })}
                    refetchData={refetch}
                />
            )}
            <SnackbarComponent/>
        </>
    );
};
